import { render, staticRenderFns } from "./AmbitLogo.vue?vue&type=template&id=0cb2585c"
import script from "./AmbitLogo.vue?vue&type=script&lang=js"
export * from "./AmbitLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports